import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
    TrackEvent,
} from '@enums';
import {
    Enum_Componentlinksproductlinks_Linksto,
    ModuleDisplayType,
} from '@graphql/generated/graphql';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { MouseEventHandler } from 'react';

type PropsType = {
    children: React.ReactNode;
    href: string;
    className?: string;
    destination_name: string;
    destination_category:
        | OutboundLinkDestinationCategory
        | Enum_Componentlinksproductlinks_Linksto;

    context: OutboundLinkContext;
    shape: OutboundLinkShape | ModuleDisplayType;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const A = styled.a`
    text-decoration: none;
    pointer-events: auto;
`;

const NewTabLink = ({
    children,
    href,
    className,
    destination_name,
    onClick,
    ...outboundLinkTrackingProps
}: PropsType) => {
    const { track } = useAnalytics();
    const { isEmbed } = useEmbedContext();

    const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.stopPropagation();
        track(TrackEvent.OutboundLink, {
            category: 'click',
            destination: href,
            destination_name: destination_name,
            ...outboundLinkTrackingProps,
        });

        if (onClick) {
            onClick(e);
        }
    };

    const getTarget = () => {
        if (href == 'javascript: void(0)') {
            return undefined;
        }
        // In embedded context, navigate the parent page (top window); otherwise open in new tab
        return isEmbed ? '_top' : '_blank';
    };

    return (
        <A
            href={href}
            target={getTarget()}
            rel='noopener'
            className={className}
            onClick={handleClick}
            aria-label={destination_name || 'Outbound Link'}
        >
            {children}
        </A>
    );
};

export default NewTabLink;
